import { LocationDescriptorObject } from 'history';
import { EnhancedLocationDescriptor } from './index';

export class ApplicationRouteGroup {
  basePath: string;
  constructor(basePath: string) {
    this.basePath = basePath;
  }
  private path(path: string, params: Partial<LocationDescriptorObject> = {}): EnhancedLocationDescriptor {
    const pathname = `/${this.basePath}${path}`;
    return {
      pathname: pathname,
      stringify() {
        const search = this.search ? `?${this.search}` : '';
        const hash = this.hash ? this.hash : '';
        return `${pathname}${hash}${search}`;
      },
      toAbsolute() {
        return `${location.origin}${this.stringify()}`;
      },
      ...params,
    };
  }
  application() {
    return this.path('');
  }
  applicationSummary() {
    return this.path(`/apply`);
  }
  applicationUserInfo() {
    return this.path(`/user_info`);
  }
  applicationSignIn() {
    return this.path(`/sign_in`);
  }
  applicationUserSummary() {
    return this.path(`/user_summary`);
  }
  applicationAddressInfo() {
    return this.path(`/user_address`);
  }
  applicationHomeLocationSelect() {
    return this.path(`/home_location`);
  }
  applicationStartDateSelect() {
    return this.path(`/start_date`);
  }
  applicationPaymentMethod() {
    return this.path(`/payment_method`);
  }
  applicationConfirmation() {
    return this.path(`/summary`);
  }
  applicationComplete() {
    return this.path(`/complete`);
  }
}

export class ApplicationRouteGroups {
  static money() {
    return new ApplicationRouteGroup('apply/money');
  }
  static beauty() {
    return new ApplicationRouteGroup('apply/beauty');
  }
}
